export const REQUEST_GET_REQUEST = 'REQUEST_GET_REQUEST';
export const REQUEST_GET_SUCCESS = 'REQUEST_GET_SUCCESS';
export const REQUEST_GET_ERROR = 'REQUEST_GET_ERROR';
export const REQUEST_GET_BY_KEY_REQUEST = 'REQUEST_GET_BY_KEY_REQUEST';
export const REQUEST_GET_BY_KEY_SUCCESS = 'REQUEST_GET_BY_KEY_SUCCESS';
export const REQUEST_GET_BY_KEY_ERROR = 'REQUEST_GET_BY_KEY_ERROR';
export const REQUEST_ADD_REQUEST = 'REQUEST_ADD_REQUEST';
export const REQUEST_ADD_SUCCESS = 'REQUEST_ADD_SUCCESS';
export const REQUEST_ADD_ERROR = 'REQUEST_ADD_ERROR';
export const REQUEST_EDIT_REQUEST = 'REQUEST_EDIT_REQUEST';
export const REQUEST_EDIT_SUCCESS = 'REQUEST_EDIT_SUCCESS';
export const REQUEST_EDIT_ERROR = 'REQUEST_EDIT_ERROR';
export const REQUEST_DELETE_REQUEST = 'REQUEST_DELETE_REQUEST';
export const REQUEST_DELETE_SUCCESS = 'REQUEST_DELETE_SUCCESS';
export const REQUEST_DELETE_ERROR = 'REQUEST_DELETE_ERROR';
